module.exports = __webpack_public_path__ + "static/media/elephants_bg.e8138268.png";